import { render } from "./Presentation.vue?vue&type=template&id=62ab4fd2&scoped=true"
import script from "./Presentation.vue?vue&type=script&lang=js"
export * from "./Presentation.vue?vue&type=script&lang=js"

import "./Presentation.vue?vue&type=style&index=0&id=62ab4fd2&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ab4fd2"]])

export default __exports__